import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Team } from '@typings/user';

type InitialState = {
  list: Team[];
};

export const initialState: InitialState = {
  list: [],
};

export const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setTeams: (state, action: PayloadAction<Team[]>) => {
      state.list = action.payload || [];
    },
  },
});

export const { setTeams } = teamsSlice.actions;

export default teamsSlice.reducer;
